import React from 'react'
import { Navigate } from 'react-router-dom'

import { useFlowSlug } from 'utils/flow'

import { useAuth } from '../../context/SearchAuth'

interface SessionSearchProtectedProps {
  children: React.ReactNode
}

const SessionSearchProtected: React.FC<SessionSearchProtectedProps> = ({ children }) => {
  const { isAuthenticated } = useAuth()
  const flowSlug = useFlowSlug() ? useFlowSlug().split('/')[0] : ''

  if (!isAuthenticated) {
    return <Navigate to={`/${flowSlug}/session-search/login`} replace />
  }

  return <>{children}</>
}

export default SessionSearchProtected
